var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"carousel"},[_c('el-carousel',{attrs:{"interval":5000,"height":"380px"}},_vm._l((_vm.data),function(item,index){return _c('el-carousel-item',{key:index},[_c('ads-item',{staticClass:"carousel-item",attrs:{"data":item,"font-size":"16px","offset":"18px"}})],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }